<!--
 * @Description: 关联表格多层级设置
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->

<template>
  <div class="page-layout-table-level">
    <jw-button size="small" type="text" @click="addTableLevel()" v-if="tableLevelConfig?.length < 2" class="add-btn"
    ><template #icon><qfei-icon-add-two-outlined /></template>添加多层级表格</jw-button
    >
    <div class="table-level-conent" v-if="tableLevelConfig?.length > 0">
      <div :class="['table-level-list', index == 1 ? 'table-level-list-2' : '']" v-for="(item, index) in tableLevelConfig" :key="index">
        <div class="table-level-left">
          <div class="col">
            {{ index == 0 ? '二' : '三' }}级表格
            <div class="del-icon-content">
              <template v-if="index == 0 && tableLevelConfig?.length == 2">
                <jw-tooltip :content="$t('删除二级表格将同步删除已配置的三级表格!')" position="lt">
                  <qfei-icon-delete-outlined class="delete-level-icon" size="16" @click="deleteTableLevel(index)" />
                </jw-tooltip>
              </template>
              <qfei-icon-delete-outlined v-else class="delete-level-icon" size="16" @click="deleteTableLevel(index)" />
            </div>
          </div>
        </div>
        <div class="table-level-right">
          <jw-form label-align="left" ref="tabelLevelForm" layout="vertical">
            <jw-form-item>
              <jw-select :trigger-props="{ updateAtScroll: true }" v-model="item.businessData" :default-popup-visible="item?.popVisible" :placeholder="$t('请选择关联对象')" :options="getTableLevelObject(index == 0 ? 1 : 0)" :fallback-option="failbackOption" :style="{ width: '100%' }" :class="{ 'error-select': isShowError(item) }" allow-search @change="objectChange($event, index)"> </jw-select>
            </jw-form-item>
            <jw-form-item>
              <jw-button class="field-config-icon" v-if="getSearchDataNums(item?.modules) > 0" size="small" type="outline" @click="tableFieldSetting(index, item?.modules)">已配置：{{ getSearchDataNums(item?.modules) }}个字段</jw-button>
              <jw-button class="field-config-icon" v-else type="outline" size="small" @click="tableFieldSetting(index, item?.modules)" :loading="index == 0 ? data.level1Loading : data.level2Loading">{{ $t('表格字段配置') }}</jw-button>
            </jw-form-item>
            <jw-form-item>
              <jw-select :trigger-props="{ updateAtScroll: true }" v-model="item.dataRange" :placeholder="$t('请选择数据范围')" :options="data.conditionConfigList" :style="{ width: '100%' }" @change="changeDataRange($event, index)"> </jw-select>
            </jw-form-item>
            <jw-form-item v-if="item.dataRange == 2">
              <jw-button class="field-config-icon" size="small" v-if="!item.dataRangeConditions" type="outline" @click="setConditionConfig(index, item?.dataRangeConditions)">{{ $t('数据条件范围配置') }}</jw-button>
              <jw-button class="field-config-icon" size="small" v-else type="outline" @click="setConditionConfig(index, item?.dataRangeConditions)"> {{ $t('tips.conditionsCount', { count: item?.dataRangeConditions?.children?.length || 0 }) }} </jw-button>
            </jw-form-item>
            <!-- 详情 ，快捷按钮-->
            <jw-form-item v-if="props.source == 20" class="btn-group-form-item">
              <btn-group :list="layoutTableBtnModules?.[index]" @cb="onBtnConfigChange" type="170" :popup-container="props.popupContainer" :btn-group-index="index" />
            </jw-form-item>
          </jw-form>
        </div>
        <div></div>
      </div>
    </div>
  </div>
  <!-- 选择字段 -->
  <field-config ref="fieldConfigRef" @cb="getFieldsCb" :empty="false" :freeze="true" :isClear="true" title="表格字段配置" />
  <!-- 设置数据条件 -->
  <show-condition ref="showConditionRef" :entity="pId" :parentBusinessData="data.parentBusinessData" @cb="senData" source="tableLevel"></show-condition>
</template>

<script setup>
import { reactive, ref, watchEffect, watch, provide, onBeforeUnmount, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import { setService } from '@/api/';
import useViewFields from '@/hooks/view-fields';
import _ from 'lodash';
const { getViewFields, enableList } = useViewFields();
import { Message } from '@arco-design/web-vue';
import { QfeiIconDeleteOutlined, QfeiIconAddTwoOutlined } from '@qfei-design/icons-vue';
import fieldConfig from '@/views/setting/sys-fields/page-layout/components/field-config/field-config.vue'; //字段配置
import showCondition from '@/views/setting/sys-fields/page-layout/components/show-condition/show-condition.vue';
import btnGroup from '@/views/setting/sys-fields/page-layout/components/btn-group/btn-group.vue'; //操作按钮组合
const fieldConfigRef = ref();
const emits = defineEmits(['cb']);
import getLayoutFields from '@/hooks/layout';
const { isDeepEmptyCondition, getBtnGroup, layoutTableBtnModules, handleEnableFields, handleModules, originalModules } = getLayoutFields();
const props = defineProps({
  tableLevelObject: {
    //可选对象列表
    type: Array,
    default: () => []
  },
  objectList: {
    //全部对象列表
    type: Array,
    default: () => []
  },
  defaultConfig: {
    //配置信息
    type: Array,
    default: () => []
  },
  parentEntityid: {
    //关联表格的对象
    type: [String, Number],
    default: ''
  },
  source: {
    //110:列表布局 20:'详情布局' 30:新建编辑
    //来源
    type: [String, Number],
    default: () => '20'
  },
  entity: {
    // 对象Id
    type: String,
    default: ''
  },
  popupContainer: {
    //挂载容器
    type: String,
    default: '.table-level-modal-body'
  }
});
const pId = ref(props.entity ? props.entity : '101');
const getSearchDataNums = (modules) => {
  return modules?.filter((el) => el?.showField && el.type == 20)?.length || 0;
};
const data = reactive({
  objectOptions: [], //关联对象列表
  conditionConfigList: [
    { value: 1, label: t('全部数据') },
    { value: 2, label: t('条件范围数据') }
  ],
  rowIndex: '',
  parentBusinessData: '',
  listData: {
    modules: []
  },
  level1Loading: false,
  level2Loading: false
});
const tableLevelConfig = ref(props.defaultConfig); //配置的信息
// 选择字段回调
const getFieldsCb = (callbackModules) => {
  console.log('layoutTableBtnModules.value)[data.rowIndex]-------', layoutTableBtnModules.value[data.rowIndex]);
  if (callbackModules) {
    //确定
    // 把按钮过滤出来
    const filterBtnList = _.cloneDeep(layoutTableBtnModules.value)[data.rowIndex]?.modules?.filter((el) => el?.showField) || [];
    // 获取字段
    const filterFieldsList = callbackModules?.modules?.filter((el) => el?.type == 20) || [];

    const resultArray = [...new Set([...filterBtnList, ...filterFieldsList])];

    tableLevelConfig.value[data.rowIndex] = { ...callbackModules, modules: resultArray };
    console.log('layoutTableBtnModules.value)[data.rowIndex]-------', tableLevelConfig.value[data.rowIndex]);
  }
};

watchEffect(() => {
  tableLevelConfig.value = props.defaultConfig;
});

// 获取关联对象表格按钮
const getBtnCollection = async (entity, index) => {
  try {
    const params = {
      entity: entity,
      position: '2', //批量操作按钮
      apiIndex: entity
    };

    const res = await setService.getBtnSetListByLayout(params);
    if (!res.error) {
      const allBtnModules = res.result
        .find((item) => item.position === '2')
        ?.values?.map((benItem) => {
          return {
            label: benItem.name,
            value: benItem.code,
            businessData: '2',
            type: '40',
            settingId: benItem.id
          };
        });

      const btnModules = _.cloneDeep(tableLevelConfig.value[index]?.modules)?.filter((item) => item.type == '40' && item.businessData == 2);
      getBtnGroup(allBtnModules, btnModules, index);
    } else {
      Message.error(res.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
  }
};
// 封装 watch 逻辑
const createWatchForBusinessData = (index) => {
  watch(
    () => tableLevelConfig.value[index]?.businessData,
    async (newVal) => {
      if (newVal) {
        await getBtnCollection(newVal, index);
      }
    },
    {
      deep: true,
      immediate: true
    }
  );
};

// 为二级和三级嵌套对象创建 watch
createWatchForBusinessData(0);
createWatchForBusinessData(1);
// 添加
const addTableLevel = () => {
  data.tableLevelConfig = tableLevelConfig.value.map((item) => ({
    ...item,
    popVisible: false
  }));

  tableLevelConfig.value.push({
    businessData: '',
    dataRange: 1,
    dataRangeConditions: [],
    modules: [],
    type: '31',
    allModules: [],
    popVisible: true
  });
  emits('cb', tableLevelConfig.value?.length);
};
//删除
const deleteTableLevel = (index) => {
  if (index == 0) {
    //全部清空
    tableLevelConfig.value = [];
  } else {
    tableLevelConfig.value.splice(index, 1);
  }
  emits('cb', tableLevelConfig.value?.length);
};
// 获取对象所有字段
const getAllFields = async (params) => {
  if (params.index == 0) {
    data.level1Loading = true;
  } else {
    data.level2Loading = true;
  }
  await getViewFields({ id: params.id });
  enableList.value = handleEnableFields(enableList.value);
  const detailEnableList = enableList.value?.filter((item) => item.fieldType != 27); //过滤掉子表单

  if (params?.type == 1) {
    //切换了对象
    tableLevelConfig.value[params.index].modules = _.cloneDeep(detailEnableList)?.filter((el) => el.type != 0); //把系统字段过滤掉;
  }
  const getModules = _.cloneDeep(tableLevelConfig.value[params.index].modules);
  await handleModules(detailEnableList, getModules);
  tableLevelConfig.value[params.index]['allModules'] = originalModules.value.allModules;
  tableLevelConfig.value[params.index].modules = originalModules.value.modules;
  if (params.index == 0) {
    data.level1Loading = false;
  } else {
    data.level2Loading = false;
  }
};
const isShowError = (item) => {
  return item?.businessData && props.tableLevelObject?.findIndex((ol) => ol?.value == item?.businessData) < 0;
};

const failbackOption = (value) => {
  const _object = props.objectList?.find((el) => el.entityType == value);
  return {
    label: _object?.entityName + (props.objectList?.length ? `（${t('异常')}）` : ''),
    value: value
  };
};

//切换关联对象及字段
const objectChange = async (val, index) => {
  tableLevelConfig.value[index].dataRangeConditions = null;
  tableLevelConfig.value[index].modules = null;

  if (val) {
    if (index == 0 && tableLevelConfig.value?.length == 2 && tableLevelConfig.value?.[1]?.dataRangeConditions) {
      tableLevelConfig.value[1].dataRangeConditions = setDataRangeConditions(tableLevelConfig.value[1].dataRangeConditions);
    }
    await getAllFields({ id: val, index: index, type: 1 });
  }
};
//打开表格字段设置
const tableFieldSetting = async (index) => {
  if (tableLevelConfig.value[index].businessData) {
    data.rowIndex = index;
    if (!tableLevelConfig.value[index]?.allModules) {
      //没有请求过字段列表
      await getAllFields({ id: tableLevelConfig.value[index].businessData, index: index, type: 0 }); //获取字段
    }
    const tableLevelConfigModule = {
      ...tableLevelConfig.value[data.rowIndex],
      modules: tableLevelConfig.value[data.rowIndex]?.modules?.filter((item) => item.type != 40)
    };
    fieldConfigRef.value?.open(tableLevelConfigModule);
    return;
  }
  Message.warning(t('请配置多层级表格的关联对象!'));
};

//设置数据条件
const showConditionRef = ref();
const setConditionConfig = (index, dataRangeConditions) => {
  if (tableLevelConfig.value[index].businessData) {
    data.rowIndex = index;
    data.parentBusinessData = index == 0 ? props.parentEntityid : index == 1 && tableLevelConfig.value[0]?.businessData ? tableLevelConfig.value[0]?.businessData : ''; //多层级表格需要互相有关联
    nextTick(() => {
      showConditionRef.value.open(dataRangeConditions, 3, tableLevelConfig.value[index].businessData);
    });
    console.log('初始化条件之后5555', data.parentBusinessData);
    return false;
  }
  Message.warning(t('请配置多层级表格的关联对象!'));
};
//三级表格对查找关联对象的校验
const setDataRangeConditions = (conditions) => {
  if (conditions.isGroup) {
    //分组
    if (conditions?.children?.length > 0) {
      conditions?.children?.forEach((el) => {
        if (el?.isGroup) {
          //分组
          el?.children?.forEach((item) => {
            if (!item.isGroup && item?.fieldType == 12 && item.operation === 'equals_current_value') {
              item.operation = '';
            }
          });
        }
      });
    }
  }
  return conditions;
};
// 改变数据范围
const changeDataRange = (v, index) => {
  tableLevelConfig.value[index].dataRange = v;
  if (v == 1) {
    tableLevelConfig.value[index].dataRangeConditions = null;
  }
};
// 快捷按钮回调
const onBtnConfigChange = (btnModules) => {
  const emitsList = btnModules.data?.modules
    ?.filter((el) => el?.showField)
    ?.map((item) => {
      return {
        label: item.label,
        type: item.type,
        value: item.value,
        businessData: '2',
        showField: true
      };
    });
  // 存储原有字段
  const preFeildsList = tableLevelConfig.value[btnModules.index]?.modules?.filter((item) => item.type != '40' || item.businessData == 0);
  const s1 = preFeildsList ? preFeildsList : [];
  const resultArray = [...new Set([...s1, ...emitsList])];
  tableLevelConfig.value[btnModules.index].modules = resultArray;
};
// 抛出表格多层级配置数据
const setTableLevelConfig = () => {
  return tableLevelConfig.value?.map((item) => {
    return {
      businessData: item.businessData,
      dataRange: item.dataRange,
      dataRangeConditions: item.dataRangeConditions,
      type: '31',
      modules: item.modules
        ?.filter((el) => el?.showField)
        ?.map((item) => {
          return {
            label: item.label,
            value: item.value,
            type: item.type,
            businessData: item?.businessData || null
          };
        })
    };
  });
};
// 获取对象列表
const getTableLevelObject = () => {
  return props.tableLevelObject;
};

const senData = (params) => {
  const condition = isDeepEmptyCondition(params);
  if (condition === null) {
    Message.warning(t('tips.conditionsConfig'));
  }
  tableLevelConfig.value[data.rowIndex].dataRangeConditions = condition;
};
const parentPosition = reactive({
  //父级元素的位置
  top: 0,
  left: 0,
  scrollTop: 0,
  parentTop: 0
});
const getParentRect = () => {
  // const reducePixels=tableLevelConfig.value?.length==1?138:0
  const tableModalRef = document.querySelector('.table-level-arco-modal');
  const tableModalBodyRef = document.querySelector('.table-level-modal-body');
  const rect = tableModalBodyRef?.getBoundingClientRect();
  parentPosition.top = rect?.top;
  parentPosition.left = 0;
  parentPosition.scrollTop = tableModalBodyRef?.scrollTop;
  parentPosition.parentTop = tableModalRef?.getBoundingClientRect()?.top - 10;

  return parentPosition;
};
const provideMethds = ref({
  getParentModalRect: getParentRect
});
provide('provideMethds', provideMethds.value);
onBeforeUnmount(() => {
  provide('provideMethds', {});
});

defineExpose({ setTableLevelConfig });
</script>
<style scoped lang="less">
@import './layout-table-level.less';
</style>
